import "react-toastify/dist/ReactToastify.min.css";

import { AppRoutes } from "./routes";
import { AuthProvider } from "./shared/contexts/auth-context";
import GlobalStyles from "./shared/styles/global";

export function App() {
	return (
		<>
			<GlobalStyles />
			<AuthProvider>
				<AppRoutes />
			</AuthProvider>
		</>
	);
}
